@if (paramDetail.initialize === true) {
  <div style="height: 95vh;">
    <gridster id='dashboard_b'
      [options]="options"
      class="noOverFlow"
      >
      @for (item of paramDetail.dockBase; track item.id) {        
        <gridster-item [item]="item"
          class="gridster-item-content col-12 inherit"
          [ngClass]="{'gridster-item-reorg': options.draggable.enabled === true}">
            @switch (item.id) {
              @case ('dockMail') {
                <div style="overflow: visible;">
                  <infosmail [visuMode]="!editMode" [bskTypeMail]="paramDetail.bskTypeMail" [infosMailDisplay]="paramDetail.infosMailDisplay" (onSaveMail)="clickSaveMail($event)"></infosmail>
                </div>
              }
              @case ('invoicevalidation') {
                <inputvalue
                  [title]="'Val_Fac' | translate"
                  [dataVariableList]="paramDetail.bskParamDock.varList"
                  [libAction]="true"
                  [editorService]="paramDetail.editorService"
                  [visuMode]="!editMode"
                  >
                </inputvalue>
              }
              @case ('maildispatching') {
                <inputvalue
                  [title]="'Mail_Dist' | translate"
                  [dataVariableList]="paramDetail.bskParamDock.varList"
                  [libAction]="true"
                  [editorService]="paramDetail.editorService"
                  [visuMode]="!editMode"
                  >
                </inputvalue>
                <dockmail
                  [editMode]="!editMode"
                  [userList]="paramDetail.bskParamDock.srcList"
                  [destList]="paramDetail.bskParamDock.trgList"
                  (onAddItem)="addItem($event)"
                  (onDelItem)="delItem($event)"
                  >
                </dockmail>
              }
              @case ('mailvalidation') {
                <inputvalue
                  [title]="'Val_Mail' | translate"
                  [dataVariableList]="paramDetail.bskParamDock.varList"
                  [libAction]="true"
                  [editorService]="paramDetail.editorService"
                  [visuMode]="!editMode"
                  >
                </inputvalue>
              }
              @case ('dockAtf') {
                <attachedfile
                  [editMode]="editMode"
                  [listAtf]="paramDetail.docAtf"
                  [scroll]="true"
                  [atfActions]="paramDetail.atfActions"
                  [isLock]="paramDetail.isLock"
                  [docId]="paramDetail.currentDocId"
                  [docName]="paramDetail.currentDocName"
                  (onUpdateAtf)="refreshAtf($event)"
                  (onClickAtfGed)="clickAtfGed($event)"
                ></attachedfile>
              }
              @case ('dockIndex') {
                <inputvalue
                  [visuMode]=!editMode
                  [title]="'Index_B' | translate"
                  [dataVariableList]="paramDetail.listBskVariableUpdate"
                  [libAction]="false"
                  [editorService]="paramDetail.editorService"
                  [btnUpdate]="paramDetail.isLock === false && editMode === true"
                  (onUpdate)="confirmUpdate()"
                  >
                </inputvalue>
              }
              @case ('dockComment') {
                <commentaires class="linepad"
                  #commentaires
                  [docId]="paramDetail.currentDocId"
                  [scroll]="true"
                  [addComm]="paramDetail.isLock === false && editMode === true"
                  [addNotif]="paramDetail.isLock === false && addNotif === true"
                  [userList]= "userList"
                  [displayUserList]="true"
                  (onSave)="clickSaveComment($event)"
                  (onComment)="onComment($event)"
                ></commentaires>
              }
              @case ('dockInfos') {
                <displayvalue [title]="'Proper' | translate" [dataLineList]="paramDetail.docInfos" [scroll]="true"></displayvalue>
              }
              @case ('dockVar') {
                @if (paramDetail.bskMode === false) {
                  @if (paramDetail.rightService.typeAction.TIdx === true) {
                    @if (editMode === true) {
                      <inputvalue
                        [visuMode]=!editMode
                        [title]="'Index_B' | translate"
                        [dataVariableList]="paramDetail.listBskVariableUpdate"
                        [libAction]="false"
                        [editorService]="paramDetail.editorService"
                        [btnUpdate]="paramDetail.rightService.typeAction.TIdx && paramDetail.isLock === false && editMode === true"
                        (onUpdate)="confirmUpdate()"
                        >
                      </inputvalue>
                    }@else {
                      <displayvalue class="col-12" [title]="'Index_B' | translate" [dataLineList]="paramDetail.docIndexFiltered" [scroll]="true"></displayvalue>
                    }
                  }
                  @if (paramDetail.rightService.typeAction.TIdx === false) {
                      <displayvalue class="col-12" [title]="'Index_B' | translate" [dataLineList]="paramDetail.docIndexFiltered" [scroll]="true"></displayvalue>
                  }                
                }
                @if (paramDetail.bskMode === true) {
                  @if (paramDetail.rightService.typeAction.TDVar === true) {
                    <displayvalue class="col-12" [title]="'Index_Doc' | translate" [dataLineList]="paramDetail.docIndexFiltered" [scroll]="true"></displayvalue>
                  }                
                }              
              }
              @case ('dockTrace') {
                @if (paramDetail.rightService.typeAction.TDTra === true) {
                  <traces #traces [docId]="paramDetail.currentDocId" [scroll]="true"></traces>
                }
              }            
              @case ('dockList') {
                @if (paramDetail.rightService.typeAction.TBList === true) {
                  <displayvalue [title]="'Baskets' | translate" [dataLineList]="paramDetail.docBasket" [scroll]="true"></displayvalue>
                }
              }
              @case ('dockBskMove') {
                <div class="col-12">
                  <p-divider align="center">
                    <span class="p-tag">{{'Tr_Bsk' | translate}}</span>
                  </p-divider>
                  <movedocs
                    [dialogMode]="false"
                    [currentAction]="'move'"
                    [visible]="true"
                    [bskMode]="paramDetail.bskMode"
                    [currentSelectedBsk]="paramDetail.currentSelectedBsk"
                    [basketMoveAll]="basketMoveAll"
                    [atfName]=""
                    [docId]=""
                    [actionGroup]="false"
                    (onSelectBasketTransfert)="selectBasketTransfert($event)"
                    >
                  </movedocs>
                </div>              
              }
              @case ('dockVersion') {
                @if (paramDetail.rightService.typeAction.TGVer === true) {
                  <div class="col-12">
                    <versionlist
                      #versionlist
                      [editMode]="editMode"
                      [docId]="paramDetail.currentDocId"
                      [delVer]="paramDetail.rightService.typeAction.TDel"
                      [viewVer]="paramDetail.rightService.typeAction.TGVer"
                      [isLock]="paramDetail.isLock"
                      (onUpdateVer)="refreshVer($event)"
                      (onViewVer)="viewVer($event)"
                      (onReadVer)="readVer($event)"
                    ></versionlist>
                  </div>                
                }              
              } 
              @case ('dockVisu') {
                <div class="full-100">
                  <p-divider align="center">
                    <span class="p-tag">{{'Doc_B' | translate}}</span>
                    @if (reorgBsk === false && paramDetail.pathPdf !== '' && paramDetail.typeView === 1) {
                      <button pButton type="button"
                        icon="pi pi-save"
                        class="p-button-rounded p-button-sm"
                        style="vertical-align: middle; margin-left: 5px;"
                        [pTooltip]="'Save' | translate"
                        (click)="onSavePdfCopy()">
                      </button>
                    }
                  </p-divider>
                  @if (reorgBsk === false) {                  
                    @if (paramDetail.typeView !== 3) {
                      <div class="full-100">
                        @if (paramDetail.pathPdf !=='' && paramDetail.typeView === 0 && paramDetail.isDesktop === true) {
                          <div class="full-100">
                            <div style="position: relative; width: 100%; height: 100%;">
                              <pdf-preview style="position: relative;" [pathPdf]="paramDetail.pathPdf+'#view=FitV'"></pdf-preview>                           
                            </div>
                          </div>
                        }
                        @if (paramDetail.pathPdf !=='' && paramDetail.typeView === 1) {
                          <div #divpdf class="innerpdf full-100">
                            <div class="innerpdf full-100" style="position: relative">
                              <ngx-extended-pdf-viewer
                                [showToolbar]="true"
                                [src]="paramDetail.pathPdf"
                                [zoom]="'page-width'"
                                [height]="'80vh'"
                                [textLayer]="true"
                                [theme]="'dark'"
                                [(page)]="currentPage"
                                [showHandToolButton]="true"
                                [handTool]="false"
                                [showOpenFileButton]="false"
                                [showDownloadButton]="false"
                                [showSidebarButton]="false"
                                [showSecondaryToolbarButton]="true"
                                [sidebarVisible]="false"
                                [activeSidebarView]="1"
                                [showDrawEditor]="true"
                                [showTextEditor]="true"
                                [showStampEditor]="true"
                                [showHighlightEditor]="true"
                                (contextmenu)="onContextMenu($event, item, 'pdf')"
                                >
                              </ngx-extended-pdf-viewer>
                            </div>
                          </div>
                        }
                        @if (paramDetail.pathImg !=='' && paramDetail.typeView === 2) {
                          <div class="gridster-item-content">
                            <img class="width-100 innerimg" [src]="paramDetail.pathImg" (contextmenu)="onContextMenu($event, item, 'img')">
                          </div>
                        }
                      </div>
                    }
                  } @else {
                    <p-skeleton height="800px" width="100%"></p-skeleton>
                  }                    
                </div>                            
              }
              @case ('dockButton') {
                <div class="grid full-100">
                  @if (editMode === true) {
                    <div class="col-12">
                      <p-divider align="center">
                        <span class="p-tag">{{'Actions' | translate}}</span>
                      </p-divider>
                      @if (paramDetail.currentSelectedBsk.bskApply === true) {
                        <button
                          type="button"
                          pButton
                          class="margin right"
                          (click)="clickApplyAction('apply')"
                          label="{{'Valid' | translate}}"
                        ></button>
                      }
                      @if (paramDetail.currentSelectedBsk.bskType === 'btAction') {
                        <div class="right">
                          @if (paramDetail.currentSelectedBsk.bskbuttonList[0].Label !== '') {
                            <p-button
                              styleClass="p-button-outlined"
                              class="margin min-btn"
                              (click)="clickApplyAction('0')"
                              >
                              <span class="font-bold">{{ paramDetail.currentSelectedBsk.bskbuttonList[0].Label }}</span>
                              <img src="{{paramDetail.currentSelectedBsk.bskbuttonList[0].url}}"
                                style="width: 1.5rem; margin-left: 5px;"/>
                            </p-button>
                          }
                          @if (paramDetail.currentSelectedBsk.bskbuttonList[1].Label !== '') {
                            <p-button
                              styleClass="p-button-outlined"
                              class="margin min-btn"
                              (click)="clickApplyAction('1')"
                              >
                              <span class="font-bold">{{ paramDetail.currentSelectedBsk.bskbuttonList[1].Label }}</span>
                              <img src="{{paramDetail.currentSelectedBsk.bskbuttonList[1].url}}"
                                style="width: 1.5rem; margin-left: 5px;"/>
                            </p-button>
                          }
                          @if (paramDetail.currentSelectedBsk.bskbuttonList[2].Label !== '') {
                            <p-button
                              styleClass="p-button-outlined"
                              class="margin min-btn"
                              (click)="clickApplyAction('2')"
                              >
                              <span class="font-bold">{{ paramDetail.currentSelectedBsk.bskbuttonList[2].Label }}</span>
                              <img src="{{paramDetail.currentSelectedBsk.bskbuttonList[2].url}}"
                                style="width: 1.5rem; margin-left: 5px;"/>
                            </p-button>
                          }
                          @if (paramDetail.currentSelectedBsk.bskbuttonList[3].Label !== '') {
                            <p-button
                              styleClass="p-button-outlined"
                              class="margin min-btn"
                              (click)="clickApplyAction('3')"
                              >
                              <span class="font-bold">{{ paramDetail.currentSelectedBsk.bskbuttonList[3].Label }}</span>
                              <img src="{{paramDetail.currentSelectedBsk.bskbuttonList[3].url}}"
                                style="width: 1.5rem; margin-left: 5px;"/>
                            </p-button>
                          }
                          @if (paramDetail.currentSelectedBsk.bskbuttonList[4].Label !== '') {
                            <p-button
                              styleClass="p-button-outlined"
                              class="margin min-btn"
                              (click)="clickApplyAction('4')"
                              >
                              <span class="font-bold">{{ paramDetail.currentSelectedBsk.bskbuttonList[4].Label }}</span>
                              <img src="{{paramDetail.currentSelectedBsk.bskbuttonList[4].url}}"
                                style="width: 1.5rem; margin-left: 5px;"/>
                            </p-button>
                          }
                        </div>
                      }
                    </div>
                  }
                </div>                            
              }
              @case ('dockReorg') {
                <div class="full-100">
                  <p-divider align="center">
                    <span class="p-tag">{{'Actions' | translate}}</span>
                  </p-divider>
                  <div class="flex-container">
                    <div class="flex-item flex-container" style="margin-right: 15px">
                      @if (paramDetail.typeView !== 3) { 
                        @if (displayReorg === true) {
                          <p-toggleButton [styleClass]="'flex-item'" onIcon="pi pi-table" offIcon="pi pi-th-large"
                            pTooltip="{{'Reorder' | translate}}"
                            [(ngModel)]="reorgBsk" (onChange)="manageDock(reorgBsk)">
                          </p-toggleButton>
                        }
                      }
                      @if (reorgBsk === true) {
                        <div class="flex-item" [ngStyle]="{'visibility': allowReorg}">
                          <i
                            pTooltip="{{'Save' | translate}}"
                            class="pi pi-save iconsave cursorPointer" (click)="saveDock(true)">
                          </i>
                          <i
                            pTooltip="{{'Init_Pos' | translate}}"
                            class="margin-left-b pi pi-replay iconsave cursorPointer" (click)="saveDock(false)">
                          </i>
                        </div>
                      }
                    </div>
                    <div class="flex-item">
                      <btntools [btnToolList]="paramDetail.btDocActionList" (clickButton)="clickDocActionList($event)"></btntools>
                    </div>
                  </div>
                </div>              
              }
              @case ('dockSignEngine') {
                  <p-divider align="center">
                    <span class="p-tag">SignEngine</span>
                  </p-divider>
                  <router-outlet name="signengine"></router-outlet>
              }
              @default {
                  @if (showCustom === true) {
                  <p-divider align="center">
                    <span class="p-tag">{{ item.label }}</span>
                  </p-divider>
                  <router-outlet name="{{ item.id }}"></router-outlet>
                  }
              }
            }
        </gridster-item>
      }
    </gridster>
    <p-contextMenu #contextMenu [model]="paramDetail.menuImage"></p-contextMenu>
  </div>
}
